<template>
  <div class="container login-container" v-loading="loading">
    <div class="box">
      <div class="logo">
        <img src="/logo.png" alt="logo"> 
      </div>
      <h2 class="title">{{ $t('login.title') }}</h2>
      <el-form :model="loginForm" :rules="rules" ref="loginForm">
        <el-form-item prop="name">
          <el-input 
            v-model="loginForm.name" 
            :placeholder="$t('common.email')"
            prefix-icon="el-icon-user">
          </el-input>
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input 
            v-model="loginForm.password" 
            type="password" 
            :placeholder="$t('common.password')"
            prefix-icon="el-icon-lock">
          </el-input>
        </el-form-item>

        <div class="remember-forgot">
          <el-checkbox v-model="loginForm.rememberMe">{{$t('login.rememberMe')}}</el-checkbox>
          <a @click="resetPassword" class="forgot-link">{{$t('login.forgotPassword')}}</a>
        </div>
        <el-button type="primary" class="submit-btn" @click="handleLogin">{{$t('login.login')}}</el-button>
      </el-form>

      <div class="bottom-link">
        {{$t('login.noAccount')}}<router-link to="/register">{{$t('login.register')}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/user'

export default {
  name: 'UserLogin',
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
        rememberMe: true
      },
      rules: {
        name: [
          { required: true, message: this.$t('loginPage.emailRequired'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('loginPage.passwordRequired'), trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    async handleLogin() {
      try {
        const valid = await this.$refs.loginForm.validate()
        if (!valid) return
        this.loading = true
        const { name, password, rememberMe } = this.loginForm
        const res = await login({ name, password, rememberMe })
        if (res.errorMessage) {
          this.$message.error(res.errorMessage)
          return;
        }
        const obj = {
          token: res.token,
          name: this.loginForm.name,
          time: new Date().getTime()
        }
        // 保存token
        localStorage.setItem('_token', JSON.stringify(obj));
        this.$message.success(this.$t('loginPage.loginSuccess'));
        // 跳转到首页或其他页面
        this.$router.push('/hot')
      } catch (error) {
        console.error('登录失败:', error)
      } finally {
        this.loading = false
      }
    },
    resetPassword(){
      this.$router.push('/change-password')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/login-common.scss';
.login-container {
  background-image: var(--login-bg-url);
}
.remember-forgot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}

.submit-btn {
  width: 100%;
  margin-top: 20px;
}

.bottom-link {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: var(--default-color);
}

@media screen and (max-width: 768px) {
  .box {
    padding: 20px;
  }
  .logo {
    margin-bottom: 0;
  }
  .logo img {
    height: 100px;
  }
  .title {
    margin-top: 0;
  }
}
</style> 